<template>
  <div>
    <div class="middle-group">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  components: {},

};
</script>
<style lang="scss">
.middle-group {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}
</style>
